import { makeObservable, observable, action, computed } from 'mobx';


export class UserState {
    id = null;
    email = null;

    constructor() {
        makeObservable(this, {
            id: observable,
            email: observable,
            //
            init: action,
        });
    }
    init(data) {
        this.id = data.id;
        this.email = data.email;
    }
}


//
// Global state to keep user ID.
//
export const userState = new UserState();
